import { DpButton } from '@/components/blocks/DpLibrary/DpButton';
import { AccountInterest } from '@/components/content/Account/parts/AccountInterest/parts/AccountInterest';
import { AccountInterestEmpty } from '@/components/content/Account/parts/AccountInterest/parts/AccountInterestEmpty';
import { AccountInterestModal } from '@/components/content/Account/parts/AccountInterest/parts/AccountInterestModal';
import { AccountInterestSkeleton } from '@/components/content/Account/parts/AccountInterest/parts/AccountInterestSkeleton';
import { Box, Typography } from '@mui/material';
import { useInterest } from 'integration/hooks/useInterest';

type Props = ReturnType<typeof useInterest>;

export const AccountInterestsCard = ({
	interests,
	isLoadingInterests,
	selectedUserInterests,
	openInterestsModal,
	onOpenInterestsModal,
	onCloseInterestsModal,
	isSubmittingInterests,
	onUpdateUserInterests,
	onToggleUserInterest,
}: Props) => (
	<>
		<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
			<Typography
				sx={{
					fontSize: 'var(--font-size-md)',
					fontWeight: 800,
					marginY: (theme) => theme.spacing(3),
				}}
			>
				INTERESES
			</Typography>
			<DpButton
				variant="text"
				sx={{
					'&:disabled': {
						color: 'var(--color-gray-500)',
					},
				}}
				disabled={interests.length === 0}
				onClick={onOpenInterestsModal}
			>
				Editar intereses
			</DpButton>
		</Box>
		<Box id="account-interests" sx={{ width: '100%' }}>
			{isLoadingInterests ? (
				<AccountInterestSkeleton />
			) : interests.length === 0 ? (
				<AccountInterestEmpty />
			) : (
				<AccountInterest interests={interests} selectedUserInterests={selectedUserInterests} />
			)}
		</Box>

		{openInterestsModal ? (
			<AccountInterestModal
				interests={interests}
				selectedUserInterests={selectedUserInterests}
				isSubmittingInterests={isSubmittingInterests}
				onToggleUserInterest={onToggleUserInterest}
				onUpdateUserInterests={onUpdateUserInterests}
				onClose={onCloseInterestsModal}
			/>
		) : null}
	</>
);
